import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./context/AuthContext"; // 👈 NEW
import { useAuth } from "./context/AuthContext";

import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import DashboardHome from "./pages/DashboardHome";
import Audiobooks from "./pages/Audiobooks";
import Chapters from "./pages/Chapters";
import Addbooks from "./pages/newbookadd";

import Users from "./pages/Users";
import CategoriesManager from "./pages/categories"; // Updated import
import SubscriberClubManager from "./pages/SubscriberClub";
import NotificationsLayout from "./pages/notifications/NotificationsLayout";
import NotificationList from "./pages/notifications/NotificationList";
import NotificationEditor from "./pages/notifications/NotificationEditor";
import ProfilePage from "./pages/ProfilePage"; // Updated import
import EditBook from "./pages/editbook"; // ✅ NEW IMPORT
import ErrorDashboard from './components/ErrorDashboard';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import AboutPage from './pages/AboutPage';
import SubscriptionPlans from './pages/SubscriptionPlans'; // MILESTONE 2
import Analytics from './pages/Analytics'; // MILESTONE 2
import Settings from './pages/Settings';

function ProtectedRoute({ children }) {
  const { currentUser, authChecked } = useAuth();

  if (!authChecked) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="categories" element={<CategoriesManager />} />
            <Route path="audiobooks" element={<Audiobooks />} />
            <Route path="audiobooks/new" element={<Addbooks />} />
            <Route path="audiobooks/edit/:id" element={<EditBook />} /> {/* ✅ NEW ROUTE */}
            <Route path="chapters" element={<Chapters />} />
            <Route path="users" element={<Users />} />
            <Route path="subscriber-club" element={<SubscriberClubManager />} />
            <Route path="subscription-plans" element={<SubscriptionPlans />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="notifications" element={<NotificationsLayout />}>
              <Route index element={<NotificationList />} />
              <Route path="create" element={<NotificationEditor />} />
            </Route>
            <Route path="/dashboard/profile" element={<ProfilePage />} />
            <Route path="/dashboard/errors" element={<ErrorDashboard />} />
            <Route path="/dashboard/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/dashboard/terms" element={<TermsPage />} />
            <Route path="/dashboard/about" element={<AboutPage />} />
            <Route path="/dashboard/settings" element={<Settings />} />
          </Route>
          {/* Catch-all: redirect unknown routes to login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer position="bottom-center" theme="dark" />
      </Router>
    </AuthProvider>
  );
}
